/**
 * @module modules/algo-select-sk
 * @description <h2><code>algo-select-sk</code></h2>
 *
 * Displays and allows changing the clustering algorithm.
 *
 * @evt algo-change - Sent when the algo has changed. The value is stored
 *    in e.detail.algo.
 *
 * @attr {string} algo - The algorithm name.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AlgoSelectSk", {
    enumerable: true,
    get: function() {
        return AlgoSelectSk;
    }
});
require("../../../elements-sk/modules/select-sk");
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _dom = require("../../../infra-sk/modules/dom");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function toClusterAlgo(s) {
    const allowed = [
        'kmeans',
        'stepfit'
    ];
    if (allowed.indexOf(s) !== -1) {
        return s;
    }
    return 'kmeans';
}
let AlgoSelectSk = class AlgoSelectSk extends _lit.LitElement {
    get algo() {
        return this._algo;
    }
    set algo(val) {
        const oldVal = this._algo;
        this._algo = toClusterAlgo(val);
        if (this._algo !== oldVal) {
            this.setAttribute('algo', this._algo);
            this.requestUpdate('algo', oldVal);
        }
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <select-sk @selection-changed=${this._selectionChanged}>
        <div
          class="kmeans"
          value="kmeans"
          ?selected=${this.algo === 'kmeans'}
          title="Use k-means clustering on the trace shapes and look for a step on the cluster centroid.">
          K-Means
        </div>
        <div
          class="stepfit"
          value="stepfit"
          ?selected=${this.algo === 'stepfit'}
          title="Look for a step in each individual trace.">
          Individual
        </div>
      </select-sk>
    `;
    }
    _selectionChanged(e) {
        let index = e.detail.selection;
        if (index < 0) {
            index = 0;
        }
        this.algo = toClusterAlgo((0, _dom.$)('div', this)[index].getAttribute('value') || '');
        const detail = {
            algo: this.algo
        };
        this.dispatchEvent(new CustomEvent('algo-change', {
            detail,
            bubbles: true
        }));
    }
    constructor(...args){
        super(...args);
        this._algo = 'kmeans';
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: String,
        noAccessor: true
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [])
], AlgoSelectSk.prototype, "algo", null);
AlgoSelectSk = _ts_decorate([
    (0, _decorators.customElement)('algo-select-sk')
], AlgoSelectSk);
